import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

export default new Vuex.Store({
  plugins: [createPersistedState()],
  state: {
    is_loading: false,
    cartOpen: false,
    cart: {
      shipping_info: {},
    },
  },
  mutations: {
    toggleCartSlider (state) {
      state.cartOpen = !state.cartOpen
    },

    closeCartSlider (state) {
      state.cartOpen = false
    },

    setCart(state, cart) {
      state.cart = cart
    },

    setLoading (state, boolean) {
      state.is_loading = boolean
    },
  },
  getters: {},
  actions: {},
})
